module.exports = __webpack_public_path__ + "img/restaurant_silhoutte.ba793ed1.png";